import Vue from 'vue';
import time from './time';

Vue.filter('time', function (value, format) {
  if (!value) return ''
  let _format = format || 'yyyy-MM-dd HH:mm:ss';
  let date = new Date(value);
  // date.setTime(value);
  return time.dateFormat(date, _format);
});

/**
 * 用户关系
 */
Vue.filter('relationship', function (value) {
  if (!value) return '';
  let newValue = '';
  switch (value) {
    case 1:
      newValue = '业主';
      break;
    case 2:
      newValue = '家属';
      break;
    case 3:
      newValue = '租客';
      break;
  }
  return newValue;
});

/**
 * 政治面貌
 */
Vue.filter('politicsStatus', function (value) {
  if (!value) return '';
  let newValue = '';
  switch (value) {
    case 1:
      newValue = '群众';
      break;
    case 2:
      newValue = '中共党员(预备党员)'
      break;
    case 3:
      newValue = '共青团员';
      break;
    case 4:
      newValue = '民主党派';
      break;
    case 0:
      newValue = '其他';
      break;
  }
  return newValue;
});

Vue.filter('sex', function (value) {
  if (!value){
    return '';
  }
  let newValue = '';
  switch (value) {
    case 0:
      newValue = '未知';
      break;
    case 1:
      newValue = '男';
      break;
    case 2:
      newValue = '女';
      break;
    case null:
      newValue = '';
      break;
    // default:
    //   newValue = '未知';
  }
  return newValue;
});

Vue.filter('digitUppercase', function (n) {
  let i;
  const fraction = ['角', '分'];
  const digit = [
    '零', '壹', '贰', '叁', '肆',
    '伍', '陆', '柒', '捌', '玖'
  ];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟']
  ];
  const head = n < 0 ? '欠' : '';
  n = Math.abs(n);
  let s = '';
  for (i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);
  for (i = 0; i < unit[0].length && n > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零元/, '元')
    .replace(/(零.)+/g, '零')
    .replace(/^整$/, '零元整');
});

  Vue.filter('card', function(value) {
    if (!value) return ''
    let newValue = '';
    switch(value) {
      case 1:
        newValue = '手机蓝牙';
        break;
      case 2:
        newValue = '蓝牙卡';
        break;
      case 4:
        newValue = 'IC卡';
        break;
      case 8:
        newValue = '临时通行';
        break;
    }
    return newValue;
  })

/**
/**
 * 优惠券状态
 * **/
Vue.filter('validStatus', function (value) {
  let newValue = '';
  switch (value) {
    case 0:
      newValue = '无效';
      break;
    case 1:
      newValue = '有效';
      break;
  }
  return newValue;
});

Vue.filter('workWeek', function (value) {
  let newValue = '';
  switch (value){
    case 1:
      newValue = '星期日';
      break;
    case 2:
      newValue = '星期一';
      break;
    case 3:
      newValue = '星期二';
      break;
    case 4:
      newValue = '星期三';
      break;
    case 5:
      newValue = '星期四';
      break;
    case 6:
      newValue = '星期五';
      break;
    case 7:
      newValue = '星期六';
      break;
  }
  return newValue;
});

/**
 * @entry 毫秒数 string/array
 * @return *时*分*秒
 */
Vue.filter('dateDiff', (value, lang = 'en') => {
  let dateDiff, dayDiff;
  if (Array.isArray(value)) {
    dateDiff = value[1] - value[0];
  } else {
    dateDiff = value;
  }
  dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
  let leave1 = dateDiff % (24 * 3600 * 1000), //计算天数后剩余的毫秒数
    hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
  //计算相差分钟数
  let leave2 = leave1 % (3600 * 1000), //计算小时数后剩余的毫秒数
    minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
  //计算相差秒数
  let leave3 = leave2 % (60 * 1000), //计算分钟数后剩余的毫秒数
    seconds = Math.round(leave3 / 1000);
  if (lang === 'en')
    return `${hours}:${minutes}:${seconds}`
  if (lang === 'cn')
    return `${dayDiff > 0 ? `${dayDiff}天` : ''}${ hours ? hours + '时' : ''}${minutes ? `${minutes}分` : ''}${seconds}秒`
});

Vue.directive('open', {
  bind: function(el,val) {
    el.onclick =function() {
      let containerDive =  document.querySelector('.home_container');
      let innderText =`
          <div class="c-mask"  @click="close"></div>
          <div class="inner">
            <div class="c-image-box">
              <img src="${el.src}" class="c-image" id="id_image_src">
              <div class="c-btn" ><i class="el-icon-close c-close c-my-close"></i></div>
            </div>
          </div>
      `
      let appDivs = document.createElement('div')
      appDivs.setAttribute("class",'wrap') 
      appDivs.setAttribute("id",'id_openImage') 
      // appDivs.id ='id_openImage'
      appDivs.innerHTML = innderText;

      containerDive.appendChild(appDivs)
      // var d = document.getElementById('id_openImage');
      // console.log(d)
      // d.style.display = 'block';
      // if(el.src) {
      //   document.getElementById('id_image_src').src = el.src;
      // }else{
      //   document.getElementById('id_image_src').src = val.value;
      // }
      let myClose =  document.querySelector('.c-my-close');
      myClose.addEventListener("click",()=>{
        myClose.removeEventListener('click',()=>{
         
        },false)
        containerDive.lastChild.remove();
      },false)

    }
  }
});

/**
 * div滚动到底部的处理
 */
Vue.directive('loadmore', {
  bind: function(el,val) {
    el.addEventListener('scroll', function() {
      let sign = 0;
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
      if (scrollDistance <= sign) {
        val.value()
      }
    })
  }
});

/**
 * 错误图片或者获取不到图片时候的默认图片处理
 */
Vue.directive('error', {
  bind: function (el, params) {
    el.onerror = function(){
      setTimeout(()=> {
        if(params.value === 'user') {
          el.src = 'static/image/user.png';
        } else if(params.value === 'lb'){
          el.src = 'static/image/err_lb.png';
        }
        else {
          // el.src = 'static/image/errImage2.png';
          el.src = 'static/image/err_icon.png';
        }
      },0)
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/filter.js